import { Divider } from 'antd';
import React from 'react';
import TermsAndPrivacy from '@portal/components/TermsAndPrivacy/TermsAndPrivacy';
import { translate } from '@portal/services/i18n';
export interface LoanContractProps {
  contractChecks: boolean;
  setContractChecks: (value: boolean) => void;
  termsOfUse: string;
}

const LoanContract = ({
  contractChecks,
  setContractChecks,
  termsOfUse,
}: LoanContractProps) => {
  return (
    <div className="loan-contract">
      <p className="loan-contract__title">
        {translate('PAGES.LOAN.SIMULATE.CONTRACT.FINISHING')}
      </p>
      <p className="loan-contract__subtitle">
        {translate('PAGES.LOAN.SIMULATE.CONTRACT.AUTHORIZE')}
      </p>
      <Divider />
      <div className="loan-contract__container">
        <TermsAndPrivacy
          title=""
          checkboxLabel={translate('PAGES.LOAN.SIMULATE.CONTRACT.ACCEPT')}
          url={termsOfUse}
          value={contractChecks}
          onChange={setContractChecks}
        />
      </div>
    </div>
  );
};

export default LoanContract;
